exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.social_button[data-v-239d3184]{padding:0}ul.social_button li[data-v-239d3184]{display:inline;margin-right:20px;cursor:pointer}.align[data-v-239d3184]{margin-top:50px;margin-right:-50%;margin-left:75%}@media (max-width:768px){.align[data-v-239d3184]{margin-right:0;margin-left:0}}.alignTop[data-v-239d3184]{margin-top:50px}.alignVideos[data-v-239d3184]{margin-top:50px;margin-right:-50%;margin-left:55%}@media (max-width:768px){.alignVideos[data-v-239d3184]{margin-right:0;margin-left:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-239d3184","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/front/Buttons.vue
// module id = +NRa
// module chunks = 70